var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.getClassName]},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: 'auto 60px auto',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        rows: '10px auto 10px',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__main`],attrs:{"layout":[
        { size: 1, x: 1, width: 11 },
        { size: 3, x: 1, width: 16 },
        { size: 4, x: 1, width: 14 },
      ]}},_vm._l((_vm.cms.main),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__main-content`,attrs:{"cms":item}})}),1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__overlay`],attrs:{"layout":[
        { size: 1, x: 3, width: 8 },
        { size: 3, x: 15, width: 6 },
        { size: 4, x: 14, width: 6 },
      ],"v-if":_vm.cms.overlay.length > 0}},_vm._l((_vm.cms.overlay),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",attrs:{"cms":item,"layout":[
          { size: 0, bound: 246, ratio: [246, 161] },
          { size: 1, bound: 246, ratio: [246, 161] },
          { size: 2, bound: 470, ratio: [470, 315] },
          { size: 3, bound: 470, ratio: [424, 276] },
        ]}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }